import React, { useState, useEffect, useContext } from 'react';
import './AverageResponse.css';
import ProgressRingIcon from '../ProgressRingIcon/ProgressRingIcon';
import formatDuration from '../../common/formatDuration';
import { CardAverageResponseContext } from '../../contexts/CardAverageResponseContext';
import logComponent from '../../common/logComponent';


export default function AverageAlarmResponseContent() {
  const [contentData, setContentData] = useState(null);
  const cardAverageResponseContext = useContext(CardAverageResponseContext);
  if (logComponent('AverageAlarmResponseContent')) { console.debug('ardAverageResponseContext rendered'); }


  useEffect(() => {
    if (logComponent('AverageAlarmResponseContent')) { console.debug('AverageAlarmResponseContent useEffect [averageResponse]'); }
    setContentData(cardAverageResponseContext.averageResponse ? { ...cardAverageResponseContext.averageResponse } : null);
  }, [cardAverageResponseContext.averageResponse]);



  return (contentData &&
    (contentData.alarmCount > 0 ?
      <div className="Average-Response__main">
        <div className="Average-Response__icon-area">
        <ProgressRingIcon className="Average-Response__icon" speed={contentData.averageResponseTimeSec} />
        <div className="Average-Response__icon-time">{formatDuration(contentData.averageResponseTimeSec, 'hH mM sS')}</div>
        </div>
        <dl className="Average-Response__info-list">
          <dt>Total alarms</dt>
        <dd>{contentData.alarmCount}</dd>
          <dt>Average response time</dt>
        <dd>{formatDuration(contentData.averageResponseTimeSec, 'hh:mm:ss')}</dd>
        </dl>
      </div> :
      <p className="Average-Response__empty-message">No alarms reported</p>)
    );
}